
import { Browse } from "@/models/browse";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { HumanFilter } from "@/utils/human-filter";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppHumanFilterListEdit from "@/components/models/HumanFilterListEdit.vue";
import { Model, getModel } from "@/utils/models/model";

export default Vue.extend({
	data() {
		return {
			browses: [] as Browse[],
		};
	},
	props: {
		view: {
			type: Object as () => View
		},
	},
	computed: {
		browse(): Browse | undefined {
			return this.browses.find((b: Browse) => b.ID == this.view.BrowseID);
		},
		model():Model | undefined{
			if (!this.browse) return undefined;
			return getModel(this.browse.Table);
		}
	},
	methods: {
		text(filter: HumanFilter): TranslateResult {
			if (!this.browse) return "";
			return filter.getTranslatedText(this.browse.type);
		}
	},
	async created() {
		this.browses = await BrowseService.getBrowses();
	},
	components: {
		AppHumanFilterListEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
